export const PHONE = 'phone';
export const EMAIL = 'email';
export const SITE = 'site';
export const SCRIPT = 'script';
